import { Link } from "react-router-dom";
import {
  CalendarClock,
  Twitter,
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  Phone,
} from "lucide-react";
import Logo from "@/assets/img/eventLogo1.svg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center">
              <img
                src={Logo}
                alt="CecureStreams Logo"
                className="h-full w-[200px] text-cecure-700"
              />
              {/* <CalendarClock className="h-8 w-8 text-cecure-700" />
              <span className="ml-2 text-xl font-bold text-cecure-900">
                CecureStream <span className="text-accent">Events</span>
              </span> */}
            </div>
            <p className="mt-4 text-gray-600 text-sm">
              Creating powerful event experiences that connect people worldwide.
              Secure, scalable, and simple.
            </p>
            <div className="mt-6 flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-accent">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-accent">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-accent">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-accent">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">
              Platform
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link
                  to="/events"
                  className="text-base text-gray-600 hover:text-cecure-700"
                >
                  Browse Events
                </Link>
              </li>
              <li>
                <Link
                  to="/create"
                  className="text-base text-gray-600 hover:text-cecure-700"
                >
                  Create Event
                </Link>
              </li>
              <li>
                <Link
                  to={"/billing"}
                  // to="/pricing"
                  className="text-base text-gray-600 hover:text-cecure-700"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/all-events"
                  className="text-base text-gray-600 hover:text-cecure-700"
                >
                  Features
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">
              Company
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <a
                  href="https://cecureintel.com/company/about-us"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-gray-600 hover:text-cecure-700"
                >
                  About Us
                </a>
              </li>

              <li>
                <Link
                  to="#"
                  // to="/contact"
                  className="text-base text-gray-600 hover:text-cecure-700"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">
              Support
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link
                  to="#"
                  // to="/help"
                  className="text-base text-gray-600 hover:text-cecure-700"
                >
                  Help Center
                </Link>
              </li>

              <li className="flex items-center text-base text-gray-600">
                <Mail className="h-5 w-5 mr-2 text-gray-400" />
                <span>helpdesk@cil.support</span>
              </li>
              <li className="flex items-center text-base text-gray-600">
                <Phone className="h-5 w-5 mr-2 text-gray-400" />
                <span>+234 2013 309293</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section with legal links */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-500">
              &copy; {currentYear} CecureStream Events. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-6">
              <Link
                to="/terms"
                className="text-sm text-gray-500 hover:text-cecure-700"
              >
                Terms of Service
              </Link>
              {/* <Link
                to="/privacy"
                className="text-sm text-gray-500 hover:text-cecure-700"
              >
                Privacy Policy
              </Link>
              <Link
                to="/cookies"
                className="text-sm text-gray-500 hover:text-cecure-700"
              >
                Cookie Policy
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
